import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export const NoAuthAlertComponent = () => {

  const { btnPrimaryColor, textPrimaryColor } = useSelector((store: any) => (store.ui));

  return (

    <div className="w-full flex justify-end pt-2 pb-2">
      <div className="noauth-alert" style={{background:btnPrimaryColor, color: textPrimaryColor}}>
        Para reservar necesitas ser huésped. <Link to={'/auth/login'}> <strong> <u> Ingresar </u> </strong> </Link>
      </div>
    </div>

  );
};
